/* eslint-disable */ 

export default {
	"types":{
	   "date":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
			 "dateDiff":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"date"
					  }
				   ]
				}
			 },
			 "isNotNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "year":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
 
				   ]
				}
			 },
			 "isValid":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isHourBetween":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  }
				   ]
				}
			 },
			 "daysDiffFromString":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "isWeekend":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isTimeBetween":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  }
				   ]
				}
			 },
			 "isWeekday":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "month":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
 
				   ]
				}
			 },
			 "dayOfMonth":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
 
				   ]
				}
			 },
			 "isNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "day":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
 
				   ]
				}
			 },
			 "isAfter":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  },
					  {
						 "type":"integer"
					  }
				   ]
				}
			 },
			 "daysDiff":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"date"
					  }
				   ]
				}
			 }
		  }
	   },
	   "EEnum__ECustomerProfileSourceType":{
		  "form":"enum",
		  "values":[
			 "Facebook",
			 "WEB_ENGAGE",
			 "WECHAT",
			 "MARTJACK",
			 "JD",
			 "ECOMMERCE",
			 "LINE",
			 "INSTORE"
		  ]
	   },
	   "string":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
			 "isNotNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "contains":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "isNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "notExists":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isEmpty":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "exists":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isValidDate":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "matches":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 }
		  }
	   },
	   "tx":{
		  "form":"object",
		  "properties":{
			 "date":{
				"returnType":"date"
			 },
			 "notes":{
				"returnType":"string"
			 },
			 "extField_store_associate_id":{
				"returnType":"string"
			 },
			 "totalQty":{
				"returnType":"real"
			 },
			 "extField_external_coupon_title":{
				"returnType":"string"
			 },
			 "extField_ship_phone":{
				"returnType":"string"
			 },
			 "discount":{
				"returnType":"real"
			 },
			 "basketAmountSum":{
				"returnType":"real"
			 },
			 "extField_cashier_name":{
				"returnType":"string"
			 },
			 "extField_delivery_date_time":{
				"returnType":"date"
			 },
			 "extField_ship_city":{
				"returnType":"string"
			 },
			 "points":{
				"returnType":"real"
			 },
			 "number":{
				"returnType":"string"
			 },
			 "basketDiscountSum":{
				"returnType":"real"
			 },
			 "extField_membership_card_swiped":{
				"returnType":"string"
			 },
			 "extField_jewellery_type":{
				"returnType":"string"
			 },
			 "extField_NPS":{
				"returnType":"integer"
			 },
			 "extField_gst_number":{
				"returnType":"string"
			 },
			 "extField_ship_last_name":{
				"returnType":"string"
			 },
			 "extField_card_number":{
				"returnType":"string"
			 },
			 "extField_delivery_staff_id ":{
				"returnType":"string"
			 },
			 "grossAmount":{
				"returnType":"real"
			 },
			 "extField_order_channel":{
				"returnType":"string"
			 },
			 "basketSize":{
				"returnType":"integer"
			 },
			 "extField_coupon_discount":{
				"returnType":"real"
			 },
			 "extField_StateGST":{
				"returnType":"real"
			 },
			 "extField_GrossWeight":{
				"returnType":"real"
			 },
			 "extField_ship_email":{
				"returnType":"string"
			 },
			 "extField_ship_address_line1":{
				"returnType":"string"
			 },
			 "extField_CentralGST":{
				"returnType":"real"
			 },
			 "extField_ship_address_line2":{
				"returnType":"string"
			 },
			 "extField_delivery_date":{
				"returnType":"date"
			 },
			 "extField_cashier_id":{
				"returnType":"string"
			 },
			 "extField_ship_zip":{
				"returnType":"string"
			 },
			 "extField_ship_date":{
				"returnType":"date"
			 },
			 "extField_external_coupon_code":{
				"returnType":"string"
			 },
			 "basketAmountSumNonDiscounted":{
				"returnType":"real"
			 },
			 "extField_MetalPurity":{
				"returnType":"real"
			 },
			 "extField_additional_discount":{
				"returnType":"real"
			 },
			 "value":{
				"returnType":"real"
			 },
			 "extField_delivery_fee":{
				"returnType":"real"
			 },
			 "extField_cod_charges":{
				"returnType":"real"
			 },
			 "extField_ship_first_name":{
				"returnType":"string"
			 },
			 "extField_delivery_charges":{
				"returnType":"real"
			 },
			 "extField_ship_state":{
				"returnType":"string"
			 },
			 "extField_booking_type":{
				"returnType":"string"
			 },
			 "extField_point_discount":{
				"returnType":"real"
			 },
			 "extField_tax_amount":{
				"returnType":"real"
			 },
			 "extField_ship_country":{
				"returnType":"string"
			 },
			 "extField_IntegratedGST":{
				"returnType":"real"
			 },
			 "extField_order_date_time":{
				"returnType":"date"
			 }
		  },
		  "methods":{
			 "basketQtyRegexBrand":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketItemDiscountSum":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "tenderCombinationRegexSum":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketCountRegexBrand":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketQtyRegexCategory":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketCountRegexCategory":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketCount":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketExcludesRegex":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketSumRegexCategory":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "customFieldValueIncludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__TxCustomField"
					  },
					  {
						 "type":"'EEnum__TxCustomField__EDepEnum__TxCustomFieldVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketIncludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketQty":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketExcludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketIncludesRegex":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "customFieldValueExcludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__TxCustomField"
					  },
					  {
						 "type":"'EEnum__TxCustomField__EDepEnum__TxCustomFieldVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketIncludesRegexBrand":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketItemDiscountSumRegex":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketCountRegex":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketSum":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "basketSumRegexBrand":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "tenderCombinationIncludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "tenderCombinationExcludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketSumRegex":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketQtyRegex":{
				"def":{
				   "form":"function",
				   "returnType":"real",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "basketIncludesRegexCategory":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 }
		  }
	   },
	   "customer.tracker":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
 
		  }
	   },
	   "integer":{
		  "form":"number",
		  "properties":{
 
		  },
		  "methods":{
			 "isNotNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 }
		  }
	   },
	   "number":{
		  "form":"primitive"
	   },
	   "org.program":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
 
		  }
	   },
	   "customer.trackerCondition":{
		  "form":"object",
		  "properties":{
			 "numberOfVisits":{
				"returnType":"integer"
			 },
			 "trackerConditionPeriod":{
				"returnType":"integer"
			 },
			 "trackerPrevAggr":{
				"returnType":"real"
			 },
			 "trackerName":{
				"returnType":"string"
			 },
			 "trackedValue":{
				"returnType":"real"
			 },
			 "trackerInitialPrevAggr":{
				"returnType":"real"
			 },
			 "trackerConditionName":{
				"returnType":"string"
			 },
			 "trackerCurrAggr":{
				"returnType":"real"
			 }
		  },
		  "methods":{
 
		  }
	   },
	   "EEnum__CustomerCluster":{
		  "form":"enum",
		  "values":[
			 "wftesting45",
			 "abc"
		  ]
	   },
	   "function":{
		  "form":"primitive"
	   },
	   "paymentMode":{
		  "form":"object",
		  "properties":{
			 "amount":{
				"returnType":"real"
			 },
			 "code":{
				"returnType":"string"
			 },
			 "notes":{
				"returnType":"string"
			 }
		  },
		  "methods":{
 
		  }
	   },
	   "org":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
 
		  }
	   },
	   "EEnum__CustomerCustomField":{
		  "form":"enum",
		  "values":[
			 "absas",
			 "address",
			 "addresslineone",
			 "addresslinetwo",
			 "addressone",
			 "addressthree",
			 "addresstwo",
			 "age_group",
			 "anniversary",
			 "areaname",
			 "asdsad",
			 "bb_svc_score",
			 "birthday",
			 "car",
			 "charity",
			 "citibank",
			 "city",
			 "comments",
			 "country",
			 "countrycode",
			 "countryname",
			 "dhjkewjh",
			 "dob",
			 "email",
			 "externalid",
			 "frwjaeff",
			 "gender",
			 "hobbies",
			 "hoby",
			 "like_rate_returnshop",
			 "lxfdyknv",
			 "male",
			 "maritalstatus",
			 "nationality",
			 "newfield",
			 "occupation",
			 "personalname",
			 "phonenumber",
			 "pincode",
			 "postaladdress",
			 "products",
			 "qayxcygj",
			 "religon",
			 "rrtest",
			 "samplefield",
			 "state",
			 "statename",
			 "street",
			 "streetname",
			 "system",
			 "systemone",
			 "test_custom",
			 "test_intouch_with_lo",
			 "testdate",
			 "testiviz",
			 "testserver",
			 "testsocial",
			 "tnc",
			 "unitnumber",
			 "vouchertestfirst",
			 "wbuwnxrq",
			 "wnqwxmjq",
			 "zipcode"
		  ]
	   },
	   "EEnum__CustomerRegistrationOrgEntity":{
		  "form":"enum",
		  "values":[
			 "CONCEPT",
			 "ZONE",
			 "STORE"
		  ]
	   },
	   "collection":{
		  "form":"object"
	   },
	   "real":{
		  "form":"object",
		  "properties":{
 
		  },
		  "methods":{
			 "isNotNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "interval":{
				"def":{
				   "form":"function",
				   "returnType":"integer",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 }
		  }
	   },
	   "store":{
		  "form":"object",
		  "properties":{
			 "name":{
				"returnType":"string"
			 },
			 "code":{
				"returnType":"string"
			 }
		  },
		  "methods":{
 
		  }
	   },
	   "enum":{
		  "form":"string"
	   },
	   "enumset":{
		  "form":"array",
		  "valueType":"enum"
	   },
	   "tx.item":{
		  "form":"object",
		  "properties":{
			 "extField_diamond_clarity":{
				"returnType":"string"
			 },
			 "extField_store_associate_id":{
				"returnType":"string"
			 },
			 "extField_external_coupon_title":{
				"returnType":"string"
			 },
			 "discount":{
				"returnType":"real"
			 },
			 "extField_tmall_sku_id":{
				"returnType":"string"
			 },
			 "extField_special_lineitem_type":{
				"returnType":"string"
			 },
			 "extField_discount_description":{
				"returnType":"string"
			 },
			 "extField_item_order_status":{
				"returnType":"string"
			 },
			 "extField_return_reason":{
				"returnType":"string"
			 },
			 "extField_DesignCode":{
				"returnType":"string"
			 },
			 "extField_jewellery_type":{
				"returnType":"string"
			 },
			 "extField_cashier_discount_reason":{
				"returnType":"string"
			 },
			 "extField_MetalWeight":{
				"returnType":"real"
			 },
			 "extField_vat_tax_percentage":{
				"returnType":"real"
			 },
			 "extField_delivery_staff_id":{
				"returnType":"string"
			 },
			 "extField_stone_weight":{
				"returnType":"real"
			 },
			 "extField_SupplierCode":{
				"returnType":"string"
			 },
			 "extField_uuid":{
				"returnType":"string"
			 },
			 "extField_vat_amount":{
				"returnType":"real"
			 },
			 "extField_imei_number":{
				"returnType":"string"
			 },
			 "extField_StoneCharge":{
				"returnType":"real"
			 },
			 "extField_diamond_color":{
				"returnType":"string"
			 },
			 "qty":{
				"returnType":"real"
			 },
			 "extField_total_unit_cost":{
				"returnType":"real"
			 },
			 "extField_coupon_discount":{
				"returnType":"real"
			 },
			 "extField_service_tax_amount":{
				"returnType":"real"
			 },
			 "extField_StateGST":{
				"returnType":"real"
			 },
			 "extField_GrossWeight":{
				"returnType":"real"
			 },
			 "extField_discounted_making_charge":{
				"returnType":"real"
			 },
			 "extField_inseam":{
				"returnType":"real"
			 },
			 "extField_delivered_from":{
				"returnType":"string"
			 },
			 "code":{
				"returnType":"string"
			 },
			 "extField_CentralGST":{
				"returnType":"real"
			 },
			 "extField_items_in_product_set":{
				"returnType":"integer"
			 },
			 "description":{
				"returnType":"string"
			 },
			 "extField_cashier_id":{
				"returnType":"string"
			 },
			 "extField_external_coupon_code":{
				"returnType":"string"
			 },
			 "extField_discount_type":{
				"returnType":"string"
			 },
			 "extField_tmall_sku_name":{
				"returnType":"string"
			 },
			 "extField_MetalRate":{
				"returnType":"real"
			 },
			 "rate":{
				"returnType":"real"
			 },
			 "extField_MakingCharge":{
				"returnType":"real"
			 },
			 "extField_MetalPurity":{
				"returnType":"real"
			 },
			 "extField_additional_discount":{
				"returnType":"real"
			 },
			 "value":{
				"returnType":"real"
			 },
			 "extField_unit_margin":{
				"returnType":"real"
			 },
			 "extField_serial_number":{
				"returnType":"string"
			 },
			 "extField_tax_code":{
				"returnType":"string"
			 },
			 "extField_size":{
				"returnType":"string"
			 },
			 "extField_promotion_code":{
				"returnType":"string"
			 },
			 "extField_purity":{
				"returnType":"string"
			 },
			 "discPercentage":{
				"returnType":"real"
			 },
			 "extField_buyer_type":{
				"returnType":"string"
			 },
			 "extField_is_addon_removed":{
				"returnType":"string"
			 },
			 "extField_booking_type":{
				"returnType":"string"
			 },
			 "extField_point_discount":{
				"returnType":"real"
			 },
			 "extField_Unit":{
				"returnType":"string"
			 },
			 "extField_tmall_order_title":{
				"returnType":"string"
			 },
			 "extField_discounted_stone_charge":{
				"returnType":"real"
			 },
			 "extField_service_tax_percentage":{
				"returnType":"real"
			 },
			 "extField_IntegratedGST":{
				"returnType":"real"
			 }
		  },
		  "methods":{
			 "doesItemMatch":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__InvAttr"
					  },
					  {
						 "type":"'EEnum__InvAttr__EDepEnum__InvAttrVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "doesBrandRegexMatch":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "doesCategoryRegexMatch":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 }
		  }
	   },
	   "boolean":{
		  "form":"primitive",
		  "properties":{
 
		  },
		  "methods":{
			 "isNotNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 },
			 "isNull":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
 
				   ]
				}
			 }
		  }
	   },
	   "referral":{
		  "form":"object",
		  "properties":{
			 "refereeRegCount":{
				"returnType":"integer"
			 },
			 "refereeTxnCount":{
				"returnType":"integer"
			 }
		  },
		  "methods":{
 
		  }
	   },
	   "EEnum__TxCustomField":{
		  "form":"enum",
		  "values":[
			 "bill_cf",
			 "govinda",
			 "ihwfwgun",
			 "test"
		  ]
	   },
	   "EEnum__InvAttr":{
		  "form":"enum",
		  "values":[
			 "A",
			 "test",
			 "testing123",
			 "Size",
			 "COLORCODE",
			 "MaterialCode",
			 "DIVISION"
		  ]
	   },
	   "transactionAddEvent":{
		  "form":"object",
		  "properties":{
			 "numberOfVisits":{
				"returnType":"integer"
			 },
			 "currentUserSource":{
				"returnType":"string"
			 },
			 "isGroupMemberTransaction":{
				"returnType":"boolean"
			 },
			 "eventType":{
				"returnType":"string"
			 },
			 "ignorePoints":{
				"returnType":"boolean"
			 }
		  },
		  "methods":{
 
		  }
	   },
	   "object":{
		  "form":"primitive"
	   },
	   "customer":{
		  "form":"object",
		  "properties":{
			 "extField_farm_size":{
				"returnType":"string"
			 },
			 "initialCurrentPoints":{
				"returnType":"real"
			 },
			 "extField_card_cash_balance":{
				"returnType":"real"
			 },
			 "lifetimePurchase":{
				"returnType":"real"
			 },
			 "extField_nationality":{
				"returnType":"string"
			 },
			 "extField_age_group":{
				"returnType":"string"
			 },
			 "extField_webengage_batch_creation_time":{
				"returnType":"date"
			 },
			 "extField_point_bal_update_date":{
				"returnType":"date"
			 },
			 "extField_nature_of_profession":{
				"returnType":"string"
			 },
			 "extField_member_type":{
				"returnType":"string"
			 },
			 "extField_kid_two_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "extField_verification_date":{
				"returnType":"date"
			 },
			 "extField_purchase_consideration":{
				"returnType":"string"
			 },
			 "extField_exercise_frequency":{
				"returnType":"string"
			 },
			 "hasWeChatProfile":{
				"returnType":"boolean"
			 },
			 "extField_webengage_last_update_batch_process_time":{
				"returnType":"date"
			 },
			 "extField_dob":{
				"returnType":"date"
			 },
			 "extField_shoe_size":{
				"returnType":"string"
			 },
			 "slabChangeDate":{
				"returnType":"date"
			 },
			 "extField_no_of_boys":{
				"returnType":"integer"
			 },
			 "extField_age_range_one":{
				"returnType":"string"
			 },
			 "extField_expect_child_in_mth":{
				"returnType":"integer"
			 },
			 "numberOfTxns":{
				"returnType":"integer"
			 },
			 "extField_kid_six_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "extField_sleep_quality":{
				"returnType":"string"
			 },
			 "slabNumber":{
				"returnType":"integer"
			 },
			 "initialLifetimePurchase":{
				"returnType":"real"
			 },
			 "lastname":{
				"returnType":"string"
			 },
			 "extField_purchase_decision_role":{
				"returnType":"string"
			 },
			 "extField_child2_gender":{
				"returnType":"string"
			 },
			 "extField_mobile_operator":{
				"returnType":"string"
			 },
			 "extField_card_issual_date":{
				"returnType":"date"
			 },
			 "extField_child4_gender":{
				"returnType":"string"
			 },
			 "extField_primary_crop":{
				"returnType":"string"
			 },
			 "extField_upper_cloth_size":{
				"returnType":"string"
			 },
			 "extField_test_date_type":{
				"returnType":"date"
			 },
			 "extField_child6_gender":{
				"returnType":"string"
			 },
			 "extField_webengage_batch_code":{
				"returnType":"string"
			 },
			 "extField_preferred_language":{
				"returnType":"string"
			 },
			 "lifetimePoints":{
				"returnType":"real"
			 },
			 "extField_living_condition":{
				"returnType":"string"
			 },
			 "extField_customer_category_7":{
				"returnType":"string"
			 },
			 "extField_child6_dob":{
				"returnType":"date"
			 },
			 "extField_customer_category_6":{
				"returnType":"string"
			 },
			 "extField_monthly_income":{
				"returnType":"real"
			 },
			 "extField_vip_pre_end_date":{
				"returnType":"date"
			 },
			 "extField_customer_category_9":{
				"returnType":"string"
			 },
			 "extField_customer_category_8":{
				"returnType":"string"
			 },
			 "extField_kid_status":{
				"returnType":"string"
			 },
			 "extField_preferred_store":{
				"returnType":"string"
			 },
			 "extField_kid_three_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "extField_health_issue":{
				"returnType":"string"
			 },
			 "extField_zip":{
				"returnType":"string"
			 },
			 "lifetimeAllPoints":{
				"returnType":"real"
			 },
			 "initialLifetimePoints":{
				"returnType":"real"
			 },
			 "isGroupMember":{
				"returnType":"boolean"
			 },
			 "extField_membership_card":{
				"returnType":"string"
			 },
			 "extField_child2_agegroup":{
				"returnType":"string"
			 },
			 "extField_point":{
				"returnType":"real"
			 },
			 "extField_city":{
				"returnType":"string"
			 },
			 "extField_preferred_socail_event":{
				"returnType":"string"
			 },
			 "extField_customer_category_1":{
				"returnType":"string"
			 },
			 "extField_customer_category_3":{
				"returnType":"string"
			 },
			 "extField_customer_category_2":{
				"returnType":"string"
			 },
			 "email":{
				"returnType":"string"
			 },
			 "extField_customer_category_5":{
				"returnType":"string"
			 },
			 "extField_verification_status":{
				"returnType":"string"
			 },
			 "extField_customer_category_4":{
				"returnType":"string"
			 },
			 "numberOfVisits":{
				"returnType":"integer"
			 },
			 "extField_residential_status":{
				"returnType":"string"
			 },
			 "extField_vip_start_date":{
				"returnType":"date"
			 },
			 "extField_age":{
				"returnType":"integer"
			 },
			 "extField_child4_dob":{
				"returnType":"date"
			 },
			 "extField_no_of_kids":{
				"returnType":"integer"
			 },
			 "extField_card_bonus_balance":{
				"returnType":"real"
			 },
			 "extField_gender":{
				"returnType":"string"
			 },
			 "extField_religion":{
				"returnType":"string"
			 },
			 "extField_area":{
				"returnType":"string"
			 },
			 "extField_spouse_dob":{
				"returnType":"date"
			 },
			 "extField_webengage_last_update_batch_code":{
				"returnType":"string"
			 },
			 "initialSlabName":{
				"returnType":"string"
			 },
			 "extField_child2_dob":{
				"returnType":"date"
			 },
			 "isTest":{
				"returnType":"boolean"
			 },
			 "extField_child1_gender":{
				"returnType":"string"
			 },
			 "extField_child5_gender":{
				"returnType":"string"
			 },
			 "extField_favorite_activity":{
				"returnType":"string"
			 },
			 "extField_vip_startdate":{
				"returnType":"date"
			 },
			 "extField_vip_pre_start_date":{
				"returnType":"date"
			 },
			 "extField_child1_dob":{
				"returnType":"date"
			 },
			 "extField_marital_status":{
				"returnType":"string"
			 },
			 "extField_sub_area":{
				"returnType":"string"
			 },
			 "extField_state":{
				"returnType":"string"
			 },
			 "currentNonRedeemablePoints":{
				"returnType":"real"
			 },
			 "extField_kid_five_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "extField_preferred_promotion":{
				"returnType":"string"
			 },
			 "extField_preferred_communication_channel":{
				"returnType":"string"
			 },
			 "joinDate":{
				"returnType":"date"
			 },
			 "extField_webengage_last_update_batch_creation_time":{
				"returnType":"date"
			 },
			 "extField_ssnNumber":{
				"returnType":"string"
			 },
			 "extField_membership_expiry_date":{
				"returnType":"date"
			 },
			 "extField_vip_enddate":{
				"returnType":"date"
			 },
			 "extField_preferred_cashier":{
				"returnType":"string"
			 },
			 "extField_external_loyalty_points":{
				"returnType":"real"
			 },
			 "extField_secondary_crop":{
				"returnType":"string"
			 },
			 "hasInstoreProfile":{
				"returnType":"boolean"
			 },
			 "extField_country_of_residence":{
				"returnType":"string"
			 },
			 "extField_binding_date":{
				"returnType":"date"
			 },
			 "extField_sales_staff":{
				"returnType":"string"
			 },
			 "extField_ethnicity":{
				"returnType":"string"
			 },
			 "currentAllPoints":{
				"returnType":"real"
			 },
			 "extField_preferred_store_3":{
				"returnType":"string"
			 },
			 "extField_preferred_store_2":{
				"returnType":"string"
			 },
			 "lifetimeNonRedeemablePoints":{
				"returnType":"real"
			 },
			 "extField_preferred_product":{
				"returnType":"string"
			 },
			 "name":{
				"returnType":"string"
			 },
			 "extField_scheme_tier":{
				"returnType":"string"
			 },
			 "extField_kid_one_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "slabExpiryDate":{
				"returnType":"date"
			 },
			 "slabName":{
				"returnType":"string"
			 },
			 "extField_household_size":{
				"returnType":"integer"
			 },
			 "extField_expiry_point_bal":{
				"returnType":"real"
			 },
			 "firstname":{
				"returnType":"string"
			 },
			 "initialSlabNumber":{
				"returnType":"integer"
			 },
			 "numberOfTxnsToday":{
				"returnType":"integer"
			 },
			 "extField_scheme_registration_date":{
				"returnType":"date"
			 },
			 "extField_create_date":{
				"returnType":"date"
			 },
			 "extField_favorite_topic":{
				"returnType":"string"
			 },
			 "extField_pre_vip_startdate":{
				"returnType":"date"
			 },
			 "extField_valuable_life_aspect":{
				"returnType":"string"
			 },
			 "extField_kid_four_birth_cpn_ex":{
				"returnType":"date"
			 },
			 "extField_recommended_customer_type":{
				"returnType":"string"
			 },
			 "extField_acquisition_channel":{
				"returnType":"string"
			 },
			 "isPrimary":{
				"returnType":"boolean"
			 },
			 "extField_wedding_date":{
				"returnType":"date"
			 },
			 "extField_preferred_payment_mode":{
				"returnType":"string"
			 },
			 "extField_customer_category":{
				"returnType":"string"
			 },
			 "extField_child5_dob":{
				"returnType":"date"
			 },
			 "extField_child1_agegroup":{
				"returnType":"string"
			 },
			 "extField_customer_status":{
				"returnType":"string"
			 },
			 "extField_webengage_batch_process_time":{
				"returnType":"date"
			 },
			 "mobile":{
				"returnType":"string"
			 },
			 "externalId":{
				"returnType":"string"
			 },
			 "extField_no_of_girls":{
				"returnType":"integer"
			 },
			 "isSecondary":{
				"returnType":"boolean"
			 },
			 "extField_born_in":{
				"returnType":"string"
			 },
			 "extField_pre_vip_enddate":{
				"returnType":"date"
			 },
			 "currentPoints":{
				"returnType":"real"
			 },
			 "extField_distance_from_nearest_store":{
				"returnType":"integer"
			 },
			 "extField_due_date":{
				"returnType":"date"
			 },
			 "extField_preferred_currency":{
				"returnType":"string"
			 },
			 "extField_child3_gender":{
				"returnType":"string"
			 },
			 "avgBasketSize":{
				"returnType":"integer"
			 },
			 "initialCurrentAllPoints":{
				"returnType":"real"
			 },
			 "isLoyal":{
				"returnType":"boolean"
			 },
			 "extField_profession":{
				"returnType":"string"
			 },
			 "isControl":{
				"returnType":"boolean"
			 },
			 "extField_vip_end_date":{
				"returnType":"date"
			 },
			 "extField_child3_dob":{
				"returnType":"date"
			 },
			 "extField_points_expiry_date":{
				"returnType":"date"
			 },
			 "avgSpendPerVisit":{
				"returnType":"real"
			 }
		  },
		  "methods":{
			 "customFieldValueExcludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerCustomField"
					  },
					  {
						 "type":"'EEnum__CustomerCustomField__EDepEnum__CustomerCustomFieldVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "includesLabelRegex":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"string"
					  }
				   ]
				}
			 },
			 "clusterValueExcludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerCluster"
					  },
					  {
						 "type":"'EEnum__CustomerCluster__EDepEnum__CustomerClusterVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "isRegisteredOn":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerRegistrationOrgEntity"
					  },
					  {
						 "type":"'EEnum__CustomerRegistrationOrgEntity__EDepEnum__CustomerRegistrationOrgEntityVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "clusterValueIncludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerCluster"
					  },
					  {
						 "type":"'EEnum__CustomerCluster__EDepEnum__CustomerClusterVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "customFieldValueIncludes":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerCustomField"
					  },
					  {
						 "type":"'EEnum__CustomerCustomField__EDepEnum__CustomerCustomFieldVal__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "doesProfileExists":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__ECustomerProfileSourceType"
					  },
					  {
						 "type":"'EEnum__ECustomerProfileSourceType__EDepEnum__ECustomerProfileSourceAccountId__' + $.parent.operands[2].value"
					  }
				   ]
				}
			 },
			 "customFieldValueExists":{
				"def":{
				   "form":"function",
				   "returnType":"boolean",
				   "params":[
					  {
						 "type":"EEnum__CustomerCustomField"
					  }
				   ]
				}
			 }
		  }
	   }
	},
	"operators":[
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "boolean",
			 "boolean"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "boolean",
			 "boolean"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"&&",
		  "operandTypes":[
			 "boolean",
			 "boolean"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"||",
		  "operandTypes":[
			 "boolean",
			 "boolean"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "real",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "real",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "real",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "integer",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "integer",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "integer",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "number",
			 "real"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"integer"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "number",
			 "integer"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"number"
	   },
	   {
		  "symbol":"-",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"number"
	   },
	   {
		  "symbol":"*",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"number"
	   },
	   {
		  "symbol":"/",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"real"
	   },
	   {
		  "symbol":"%",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"number"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "number",
			 "number"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "string",
			 "string"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "string",
			 "string"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"+",
		  "operandTypes":[
			 "string",
			 "string"
		  ],
		  "type":"string"
	   },
	   {
		  "symbol":"==",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"<=",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":">=",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   },
	   {
		  "symbol":"!=",
		  "operandTypes":[
			 "date",
			 "$.operands[0].type"
		  ],
		  "type":"boolean"
	   }
	],
	"identifiers":{
	   "currentEvent":{
		  "returnType":"transactionAddEvent",
		  "desc":""
	   },
	   "currentTrackerCondition":{
		  "returnType":"customer.trackerCondition",
		  "desc":""
	   },
	   "tenderProfile":{
		  "returnType":"paymentMode",
		  "desc":""
	   },
	   "currentTracker":{
		  "returnType":"customer.tracker",
		  "desc":""
	   },
	   "currentCustomer":{
		  "returnType":"customer",
		  "desc":""
	   },
	   "groupPrimaryCustomer":{
		  "returnType":"customer",
		  "desc":""
	   },
	   "currentTxn":{
		  "returnType":"tx",
		  "desc":""
	   },
	   "currentLineItem":{
		  "returnType":"tx.item",
		  "desc":""
	   },
	   "organization":{
		  "returnType":"org",
		  "desc":""
	   },
	   "referrerCode":{
		  "returnType":"referral",
		  "desc":""
	   },
	   "program":{
		  "returnType":"org.program",
		  "desc":""
	   },
	   "currentStore":{
		  "returnType":"store",
		  "desc":""
	   }
	}
 };